import { useEffect } from "react";
import { createPortal } from "react-dom";

import { t } from "i18n/i18n";
import { Modal } from "mds/components/Modal";
import { useAppSelector } from "store/index";
import { selectShowForceReloadModal } from "store/selectors/view";
import { BUTTON_EVENT_CATEGORY, trackEvent } from "utils/amplitude";
import { clearCacheAndReload } from "utils/urls";

export const ForceReloadModal = () => {
  const showForceReloadModal = useAppSelector(selectShowForceReloadModal);

  useEffect(() => {
    if (showForceReloadModal) {
      trackEvent("Force reload modal displayed", BUTTON_EVENT_CATEGORY);
    }
  }, [showForceReloadModal]);

  if (!showForceReloadModal) {
    return null;
  }

  const handleReload = () => {
    trackEvent("Force reload modal - Reload clicked", BUTTON_EVENT_CATEGORY);
    clearCacheAndReload();
  };

  return (
    <>
      {createPortal(<div className="modal-backdrop z-[10000]" />, document.body)}
      <Modal
        allowManualClose={false}
        className="confirm-modal z-[10001]"
        confirmButtonText={t("warning.force_reload.reload_button")}
        labelText={t("warning.force_reload.message")}
        title={t("warning.force_reload.title")}
        hideCancelButton
        hideCloseButton
        onConfirm={handleReload}
      />
    </>
  );
};
